import { HomeLoadedProps } from "./../Provider/HomeProvider";
import { BREAKPOINT_MOBILE, BREAKPOINT_TABLET } from "Styles/media";
import theme from "Styles/theme";
import * as THREE from "three";
import { PlanetProps } from "Data/planet";
import { renderShape, materialDefault } from "./util";
import { renderRing, renderSatellite, satelliteAnimation, ringAnimation } from "./planet";
import { is_touch_device } from "../util";

let width: number;
let height: number;
let camera: THREE.OrthographicCamera;
let renderer: THREE.WebGL1Renderer;
let scene: THREE.Scene;
let planet_arr: any;
let frameCount: number = 0;
let hoverId: string;

export const render = (dom: HTMLDivElement, data: PlanetProps[], setHomeLoaded: React.Dispatch<React.SetStateAction<HomeLoadedProps>>) => {
	init(dom, data, setHomeLoaded);
	animate();
	window.addEventListener("resize", () => onResize(dom));
};

export const init = (dom: HTMLDivElement, data: PlanetProps[], setHomeLoaded: React.Dispatch<React.SetStateAction<HomeLoadedProps>>) => {
	width = dom.getBoundingClientRect().width;
	height = dom.getBoundingClientRect().height;

	// SCENE
	scene = new THREE.Scene();

	// CAMERA
	camera = new THREE.OrthographicCamera(width * -0.5, width * 0.5, height * 0.5, height * -0.5, 1, 5000);
	camera.position.z = 1000;

	// LIGHT
	// -light
	const ambientLight = new THREE.AmbientLight("white", 0.1);
	scene.add(ambientLight);

	const pointLight = new THREE.PointLight("white", 1.2);
	pointLight.position.set(1000, 1200, 2000);
	scene.add(pointLight);

	const backLight = new THREE.PointLight(`#0dfffb`, 0.5);
	backLight.position.set(-100, 0, -200);
	scene.add(backLight);

	// OBEJCT
	planet_arr = data.map((el, i) => {
		const group = new THREE.Group();
		const radius = theme.size.three.planet_radius;

		// --zPlanet / planet
		const planet_geo = renderShape(el.shape, radius);
		const planet_mat = materialDefault({ color: theme.color.three[el.color] });
		const planet = new THREE.Mesh(planet_geo, planet_mat);

		planet.rotation.x += (Math.random() * Math.PI) / 2 - Math.PI / 4;
		planet.rotation.y += (Math.random() * Math.PI) / 2 - Math.PI / 4;
		planet.rotation.z += (Math.random() * Math.PI) / 2 - Math.PI / 4;
		group.add(planet);

		// --zPlanet / sub
		let ring;
		if (el.ring) {
			ring = renderRing(el.ring, group, radius);
			ring.rotation.x += (Math.random() * Math.PI) / 2 - Math.PI / 4;
			ring.rotation.y += (Math.random() * Math.PI) / 2 - Math.PI / 4;
			group.add(ring);
		}

		let satellite;
		if (el.satellite) {
			satellite = renderSatellite(el.satellite, group, radius);
			group.add(satellite);
		}

		group.position.x = getPosition(width, height, i).x;
		group.position.y = getPosition(width, height, i).y;
		scene.add(group);
		return {
			...el,
			group,
			planet,
			ring: {
				...el.ring,
				mesh: ring
			},
			satellite: {
				...el.satellite,
				mesh: satellite
			},
			listFrameCount: 0
		};
	});

	// RENDERER
	renderer = new THREE.WebGL1Renderer({
		alpha: true
	});
	renderer.setSize(width, height);
	renderer.setClearColor(0x000000, 0);
	renderer.render(scene, camera);
	dom.appendChild(renderer.domElement);

	setHomeLoaded((n) => ({
		...n,
		list: true
	}));
};

const onResize = (dom: HTMLDivElement) => {
	width = dom.getBoundingClientRect().width;
	height = dom.getBoundingClientRect().height;

	camera.left = width * -0.5;
	camera.right = width * 0.5;
	camera.top = height * 0.5;
	camera.bottom = height * -0.5;

	camera.position.z = 1000;
	camera.updateProjectionMatrix();

	planet_arr.forEach((el: any, index: number) => {
		el.group.position.x = getPosition(width, height, index).x;
		el.group.position.y = getPosition(width, height, index).y;
	});

	renderer.setSize(width, height);
	renderer.render(scene, camera);
};

const getCameraSize = (WrapperWidth: number) => {
	const width = WrapperWidth / getCol();

	if (window.innerWidth > BREAKPOINT_MOBILE) {
		let height = (width * theme.size.three.listRatio) / 100;
		return {
			width,
			height
		};
	} else {
		let height = (width * theme.size.three.listRatio_min) / 100;
		if (height > 250) {
			height = 250;
		}
		return {
			width,
			height
		};
	}
};

const getCol = () => {
	if (window.innerWidth > BREAKPOINT_TABLET) {
		return 3;
	} else {
		return 1;
	}
};

const getPosition = (wrapperWidth: number, wrapperHeight: number, index: number) => {
	const init_x = wrapperWidth * -0.5 + getCameraSize(width).width / 2;
	const init_y = wrapperHeight * 0.5 - getCameraSize(width).height / 2;

	const col = Math.floor(index % getCol());
	const row = Math.floor(index / getCol());

	const x = init_x + col * getCameraSize(width).width;
	const y = init_y - row * getCameraSize(width).height;

	return {
		x,
		y
	};
};

export const animate = () => {
	frameCount++;
	requestAnimationFrame(animate);

	planet_arr.forEach((el: any) => {
		if (is_touch_device()) {
			el.planet.rotation.x += 0.01;
			el.planet.rotation.y += 0.01;
			el.planet.rotation.z += 0.01;

			if (el.satellite.mesh) {
				satelliteAnimation(el.satellite, frameCount * -1, theme.size.three.planet_radius);
			}

			if (el.ring.mesh) {
				ringAnimation(el.ring, frameCount);
			}
		} else {
			if (el.id === hoverId) {
				el.listFrameCount++;

				el.planet.rotation.x += 0.01;
				el.planet.rotation.y += 0.01;
				el.planet.rotation.z += 0.01;

				if (el.satellite.mesh) {
					satelliteAnimation(el.satellite, el.listFrameCount * -1, theme.size.three.planet_radius);
				}

				if (el.ring.mesh) {
					ringAnimation(el.ring, el.listFrameCount);
				}
			}
		}
	});

	renderer.render(scene, camera);
};

export const getHoverId = (id: string) => {
	hoverId = id;
};
